function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "logotipos"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "120.78 44.09 96.63 2.25 72.47 44.09 48.31 85.93 24.16 127.77 72.47 127.77 96.63 85.93 120.78 127.77 169.1 127.77 144.94 85.93 120.78 44.09"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "48.31 169.61 24.16 127.77 0 169.61 48.31 169.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "96.63 169.61 120.78 127.77 72.47 127.77 96.63 169.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "193.25 169.61 169.1 127.77 144.94 169.61 193.25 169.61"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M896.07,2.12H933L857.73,169.61H828.32L753,2.12h38.11l52.23,121.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M946.18,169.61V2.12h36.7V169.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1038.51,166.67q-17.54-5.05-29-14.23l11.76-26.35A92.28,92.28,0,0,0,1075.33,143q16,0,24.58-5.06t8.58-14.23q0-8-7.88-12.59T1073,102.33q-22.11-4.45-35.17-10.94t-19-15.76q-6-9.28-6-23.17a46.2,46.2,0,0,1,8.35-27q8.36-12,23.41-18.7T1079.33,0a113.9,113.9,0,0,1,34.34,5.18q16.47,5.18,26.35,14.11l-11.76,26.35q-22.12-16.93-48.7-16.94-14.11,0-22.58,5.65t-8.47,15.29a14.13,14.13,0,0,0,3.17,9.41q3.18,3.77,10.71,6.7t21.4,5.76q32.24,7.06,46.47,18.35t14.23,30.82q0,23.53-18.35,37.29t-51.05,13.76A131.33,131.33,0,0,1,1038.51,166.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1171.07,169.61V2.12h36.7V169.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1274.93,161.26a70.56,70.56,0,0,1-28.46-30q-10-19.53-10-45.64t10-45.4a70.9,70.9,0,0,1,28.46-29.76Q1293.4,0,1318.33,0t43.29,10.47a70.44,70.44,0,0,1,28.23,29.76q9.89,19.29,9.88,45.4t-9.88,45.64a70.11,70.11,0,0,1-28.23,30q-18.34,10.47-43.29,10.47T1274.93,161.26Zm76.46-33q11.86-14.82,11.88-42.58t-11.88-42.34q-11.88-14.59-33.06-14.59t-33,14.59q-11.88,14.58-11.88,42.34,0,28,11.88,42.7t33,14.7Q1339.51,143,1351.39,128.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1535,2.12h34.59V169.61h-27.29l-83.51-106.8v106.8h-34.35V2.12h27L1535,108.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M210,169.61V2.12h36.69V139.74h74.81v29.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M343.81,169.61V2.12h36.7V169.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M536.94,2.12h36.94L498.6,169.61H469.19L393.91,2.12H432l52.23,121.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M587.05,169.61V2.12h115.5V30.58H622.81V70.11h74.8V98.8h-74.8v42.35h79.74v28.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1149.59,308.62v-73h-28V222.82h71.58v12.77h-28v73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1220.93,309.46a33.21,33.21,0,0,1-16.45-3.86,26.31,26.31,0,0,1-10.67-10.9,35.47,35.47,0,0,1-3.73-16.81,35.89,35.89,0,0,1,3.73-16.81,26.17,26.17,0,0,1,10.67-11,33.31,33.31,0,0,1,16.45-3.85,32.79,32.79,0,0,1,16.2,3.85,26.54,26.54,0,0,1,10.73,11,35.42,35.42,0,0,1,3.79,16.81,35,35,0,0,1-3.79,16.81,26.7,26.7,0,0,1-10.73,10.9A32.68,32.68,0,0,1,1220.93,309.46Zm0-11.57q7.47,0,11.5-5t4-15q0-9.88-4-14.88t-11.5-5q-7.59,0-11.75,5T1205,277.89q0,10,4.1,15T1220.93,297.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1286.6,309.46q-11.2,0-16.81-6.21t-5.61-18.73V247.76h15.07v36.88q0,6.63,2.77,9.76t8.31,3.13a13.71,13.71,0,0,0,10.61-4.34q4-4.33,4-11.57V247.76h15.19v60.86h-14.7V296.08L1307,296a20.72,20.72,0,0,1-8,10.06A22.33,22.33,0,0,1,1286.6,309.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1336.24,308.62V265q0-4.22-.18-8.61a86.52,86.52,0,0,0-.78-8.62h14.22l1.68,15.67-1.68-.85q1.56-8.07,7.11-12.17a20.54,20.54,0,0,1,12.53-4.09,22.26,22.26,0,0,1,3.37.24,12.55,12.55,0,0,1,2.77.72L1375,261a20.25,20.25,0,0,0-8-1.57,16.33,16.33,0,0,0-8.86,2.17,13.87,13.87,0,0,0-5.18,5.84,19.12,19.12,0,0,0-1.75,8.26v32.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1382.75,220.17h16.75V235h-16.75Zm.73,88.45V247.76h15.06v60.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1437.22,309.46q-16.63,0-26.27-7.59l4.22-10.61a35.23,35.23,0,0,0,10.48,5.43,38.76,38.76,0,0,0,11.81,1.8q5.55,0,8.44-1.8a5.7,5.7,0,0,0,2.89-5.07,5.33,5.33,0,0,0-2-4.39c-1.37-1.09-3.7-2-7-2.84l-10.12-2.28q-8.31-1.82-12.47-6.09a15,15,0,0,1-4.16-10.9,16.21,16.21,0,0,1,3.13-9.83,20.51,20.51,0,0,1,8.8-6.68,33.22,33.22,0,0,1,13.13-2.41,39.94,39.94,0,0,1,12.54,2,31.62,31.62,0,0,1,10.48,5.73l-4.34,10.36a34.35,34.35,0,0,0-9.34-5.18,28.25,28.25,0,0,0-9.46-1.69c-3.45,0-6.14.65-8.07,1.93a6.05,6.05,0,0,0-2.89,5.3,5.39,5.39,0,0,0,1.74,4.22q1.76,1.57,6.09,2.53l10.24,2.53q9,1.93,13.2,6.21t4.15,11.26a15.46,15.46,0,0,1-6.74,13.2Q1448.91,309.46,1437.22,309.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1475.18,308.62V265q0-4.22-.18-8.61a86.51,86.51,0,0,0-.79-8.62h14.22l1.33,12.05-1.33.12a20.55,20.55,0,0,1,7.71-10.12,21.74,21.74,0,0,1,12.54-3.61q8.55,0,13.43,4.27t6.33,13.08l-2.89-2.65a21.77,21.77,0,0,1,8.19-10.67,23,23,0,0,1,13.5-4q10.23,0,15.3,6.2t5.06,18.86v37.36h-15.06V271.74q0-7-2.35-10.3t-7.77-3.31a12,12,0,0,0-9.83,4.39q-3.55,4.41-3.55,12.11v34H1514V271.74q0-7-2.47-10.3t-7.77-3.31q-6.39,0-10,4.39t-3.55,12.11v34Z"
})));

function SvgAliveVisionTourismWhiteLogomarca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1569.58 309.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alive_vision_tourism_whiteLogomarca") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliveVisionTourismWhiteLogomarca);
export default __webpack_public_path__ + "static/media/alive_vision_tourism_whiteLogomarca.1fbbf705.svg";
export { ForwardRef as ReactComponent };